import { createContext } from "react";

type LoadingContextType = React.MutableRefObject<any>;

const LoadingContext = createContext<LoadingContextType>(null);

export default LoadingContext;
